import {
  BIM_VIEWER_SELECT_OBJECT,
  ISSUE_CREATE,
  ISSUE_EDIT,
  ISSUE_FIND_USER,
  MEASUREMENT_SELECT,
  PROJECT_SELECT,
} from "../../../../../typesAction";

const INITIAL_STATE = {
  data: {},
  modelName: null, //TODO set this to BIM model name, once BIM model upload is completed
  bimNotes: [],
  selectedNoteId: null,
  selectedNoteObj: {},
  users: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case PROJECT_SELECT:
      return {
        ...state,
        selectedProject: action.payload.id,
        selectedProjectObj: action.payload,
      };
    case BIM_VIEWER_SELECT_OBJECT:
      return {
        ...state,
        data: action.payload.data,
        modelId: action.payload.modelId,
        bimNotes: action.payload.bimNotes,
      };
    case ISSUE_CREATE:
      return { ...state, bimNotes: [...state.bimNotes, action.payload] };
    case ISSUE_EDIT:
      return {
        ...state,
        bimNotes: [
          ...state.bimNotes.filter((note) => {
            return note["@id"] !== action.payload["@id"];
          }),
          action.payload,
        ],
      };
    case MEASUREMENT_SELECT:
      return {
        ...state,
        selectedNoteId: action.payload.selectedNoteId,
        selectedNoteObj: action.payload.selectedNoteObj,
        activeNodes: action.payload.activeNodes,
      };
    case ISSUE_FIND_USER:
      return {
        ...state,
        users: action.payload["hydra:member"].map((user) => {
          let obj = {};
          obj.label = user.username;
          obj.value = user["@id"];
          return obj;
        }),
      };
    default:
      return state;
  }
}
